module.exports = __webpack_public_path__ + "media/my-account/letter--pink-93da2774.svg";